import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { globalStyles } from '@/themes/commonStyles/global';
import { Palette } from '@/themes/themeOverrides/Palette';
import { resizerIconDataUri } from '@/assets/icons/resizerIconDataUri.js';
import { customDialogRightStyles } from '@/themes/commonStyles/CustomDialogRight';

export const MuiPaperStyles = {
    styleOverrides: {
        root: {
            '@keyframes dots': {
                '0%': { content: '""' },
                '25%': { content: '"."' },
                '50%': { content: '".."' },
                '75%': { content: '"..."' },
                '100%': { content: '""' },
            },
            boxShadow: 'none',
            borderRadius: 0,
            '& .autocomplete-parent': {
                ...globalStyles.autocompleteParent,
            },
            '& .pos-form-content': {
                '& .MuiTypography-h6': {
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        marginTop: '16px',
                    },
                },
            },
            '&.custom-dialog-right': {
                '&--no-overflow': {
                    '& .MuiPaper-root': {
                        overflow: 'inherit !important',
                    },
                },
                width: 'fit-content',
                minWidth: 'auto',
                height: '100%',
                minHeight: '100%',
                position: 'fixed',
                right: '0',
                maxWidth: '100%',
                margin: '0',
                backgroundColor: 'transparent',
                overflowY: 'visible',
                [`@media (min-width: ${breakpoints.values.md}px)`]: {
                    minWidth: '540px',
                },
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    minWidth: '100%',
                    maxWidth: '100%',
                },
                '&.full-width': {
                    maxWidth: '100%',
                    minWidth: '100%',
                },
                '&--no-resizer': {
                    maxWidth: '540px',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        maxWidth: '100%',
                    },
                    '& .dialog-resizer-handle': {
                        display: 'none !important',
                    },
                },
                '& .custom-dialog-right__inner': {
                    backgroundColor: Palette.white,
                    boxShadow: Palette.boxShadow.elevation16,
                    overflowX: 'hidden',
                    minHeight: '100%',
                },
                '& .MuiCollapse-root.MuiCollapse-entered, & .MuiCollapse-entered .MuiCollapse-wrapper, & .MuiCollapse-entered .MuiCollapse-wrapperInner': {
                    overflow: 'visible',
                },
                '& .scroll-container': {
                    overflow: 'visible',
                },
                '& .RaDatagrid-root .RaDatagrid-tableWrapper': {
                    marginLeft: 0,
                    marginRight: 0,
                    '& .RaDatagrid-table': {
                        overflow: 'visible',
                    },
                },
                '& .dialog-resizer-handle': {
                    position: 'absolute',
                    left: '-6px',
                    top: '0',
                    width: '6px',
                    height: '100%',
                    cursor: 'ew-resize',
                    zIndex: 1000,
                    backgroundColor: 'transparent',
                    transition: 'background-color 0.2s ease',
                    display: 'none',
                    [`@media (min-width: ${breakpoints.values.lg}px)`]: {
                        display: 'block',
                    },
                    '&:hover': {
                        boxShadow: `-2px 0px 0px 0px inset ${Palette.yellow.yellow200}`,
                        '&::after': {
                            outline: `2px solid ${Palette.yellow.yellow200}`,
                            boxShadow: `0 0 0 2px inset ${Palette.black}`,
                        },
                    },
                    '&:active': {
                        boxShadow: `-2px 0px 0px 0px inset ${Palette.yellow.yellow200}`,
                        '&::after': {
                            outline: `2px solid ${Palette.yellow.yellow200}`,
                            boxShadow: `0 0 0 2px inset ${Palette.black}`,
                        },
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: '-14px',
                        width: '36px',
                        height: '36px',
                        backgroundColor: Palette.white,
                        backgroundImage: resizerIconDataUri,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        borderRadius: '10px',
                        boxShadow: `0 4px 12px -2px rgba(0, 0, 0, 0.02), 0 4px 6px -4px rgba(0, 0, 0, 0.02)`,
                        '&:hover, &:active': {
                            outline: `2px solid ${Palette.yellow.yellow200}`,
                            boxShadow: `0 0 0 2px inset ${Palette.black}`,
                        },
                    },
                },
                '&--wide': {
                    minWidth: '880px',
                    maxWidth: '880px',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        maxWidth: '100%',
                        minWidth: '100%',
                    },
                },
                '&--medium': {
                    width: '100%',
                    minWidth: '100%',
                    [`@media (min-width: ${breakpoints.values.md}px)`]: {
                        minWidth: 'auto',
                        width: '720px',
                        maxWidth: '720px',
                    },
                },
                '&--small': {
                    width: '100%',
                    minWidth: '100%',
                    [`@media (min-width: ${breakpoints.values.md}px)`]: {
                        minWidth: 'auto',
                        width: '480px',
                        maxWidth: '480px',
                    },
                },
                '& .create-page .RaCreate-main': {
                    marginTop: '0',
                    '& .MuiPaper-elevation': {
                        boxShadow: 'none',
                    },
                    '& .date-picker': {
                        width: '100%',
                        '& .rs-picker-date': {
                            maxWidth: '100%',
                            minWidth: '100%',
                            marginBottom: '8px',
                        },
                    },
                },
                '& .category-form-wrapper': {
                    position: 'relative',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        height: '2px',
                        backgroundColor: Palette.gray.gray100,
                        bottom: '110px',
                        left: 0,
                        width: '100%',
                    },
                    '& > .MuiCardContent-root': {
                        marginBottom: '43px',
                    },
                    '& .tag-category-list-manager': {
                        '& .RaSimpleFormIterator-form': {
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            columnGap: 'unset',
                            marginBottom: '-2px',
                            width: '100%',
                            '& .MuiIconButton-root': {
                                marginTop: '8px',
                            },
                            '& .ra-input': {
                                '& .MuiFormHelperText-root': {
                                    display: 'none',
                                    '&.Mui-error': {
                                        display: 'block',
                                    },
                                },
                            },
                        },
                        '& .RaSimpleFormIterator-line': {
                            marginBottom: 0,
                            '& .RaSimpleFormIterator-form': {
                                margin: '0px',
                                gap: '12px',
                                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                                    display: 'flow-root',
                                    marginBottom: '20px',
                                },
                                '& .MuiButtonBase-root + .MuiButtonBase-root': {
                                    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                                        marginLeft: '12px',
                                    },
                                },
                            },
                            '& .RaSimpleFormIterator-add': { margin: '16px 0 0 112px' },
                            '& .MuiInputLabel-root.MuiInputLabel-formControl': {
                                transform: 'translate(14px, -11px) scale(1)',
                                display: 'none',
                            },
                        },
                        '& .RaSimpleFormIterator-buttons': {
                            margin: '16px 0 0 110px',
                        },
                    },
                },
                '& .popup-wrapper-top': {
                    ...customDialogRightStyles.popupWrapper,
                },
                '& .popup-box--header': {
                    ...customDialogRightStyles.popupBoxHeader,
                },
                '& .popup-wrapper': {
                    padding: '40px 56px 34px',
                    width: '100%',
                    boxSizing: 'border-box',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        padding: '24px 20px',
                    },
                    '&.collapsible-section': {
                        padding: '0px',
                    },
                    '&.border-bottom': {
                        borderBottom: `2px solid ${Palette.gray.gray100}`,
                    },
                    '&.no-padding-bottom': {
                        paddingBottom: '0',
                    },
                    '&--small': {
                        padding: '32px 56px',
                    },
                    '&--footer': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        '& .MuiToolbar-gutters': {
                            alignItems: 'flex-start',
                            '& .MuiButton-containedPrimary svg.MuiSvgIcon-root': {
                                display: 'none',
                            },
                        },
                    },
                    '& .ra-input-logo': {
                        marginBottom: '0 !important',
                    },
                    '& .category-name': {
                        marginBottom: '-2px',
                    },
                    '& .select-with-icon': {
                        marginBottom: '-5px',
                    },
                    '& .MuiCardContent-root': {
                        position: 'relative',
                        marginBottom: '74px',
                    },
                    '& .filter-field': {
                        width: '100%',
                        '& .custom-select-array-input': {
                            width: '100%',
                            '& .MuiFormControl-root': {
                                height: '44px',
                                maxWidth: 'calc(100% - 4px)',
                                '& .MuiFormLabel-root': {
                                    backgroundColor: Palette.white,
                                },
                            },
                        },
                    },
                    '& .MuiTablePagination-root': {
                        display: 'block',
                        borderBottom: `2px solid ${Palette.gray.gray100}`,
                        overflow: 'hidden',
                        position: 'relative',
                        '& .MuiTablePagination-toolbar': {
                            boxSizing: 'border-box',
                            padding: '16px',
                            marginTop: '4px',
                            border: 'none',
                            '& .MuiButton-text': {
                                padding: '12px 20px',
                                backgroundColor: Palette.gray.gray100,
                            },
                        },
                    },
                    '& .date-picker': {
                        '& .rs-picker-date': {
                            maxWidth: '100%',
                            minWidth: '100%',
                            marginBottom: '32px',
                        },
                    },
                },
                '& .device-details-collapse-wrapper': {
                    '& .popup-box--header h5': {
                        marginBottom: '0px',
                    },
                    '& .device-details-collapse-button': {
                        position: 'absolute',
                        zIndex: 2,
                        top: '-92px',
                        right: '54px',
                        padding: '12px 20px',
                        lineHeight: '20px',
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            display: 'none',
                        },
                    },
                    '& .device-details-collapse-list': {
                        marginTop: '0',
                    },
                    '& .extended-table': {
                        '& .scroll-container': {
                            overflow: 'visible',
                            '& .RaDatagrid-tableWrapper': {
                                minWidth: 'calc(100% + 56px)',
                                borderTopRightRadius: '0px',
                                '& .RaDatagrid-table': {
                                    borderTopRightRadius: '0px',
                                },
                            },
                        },
                    },
                },
                '& .popup-wrapper + .popup-wrapper': {
                    '&.border-bottom': {
                        borderBottom: 'none',
                    },
                },
                '& .popup-box': {
                    margin: '0',
                    '& .edit-page, & .create-page': {
                        '& .MuiPaper-root.MuiPaper-elevation': {
                            overflow: 'unset',
                        },
                        '& .MuiGrid-root.MuiGrid-direction-xs-row': {
                            minWidth: '100%',
                        },
                    },
                    '& .show-page': {
                        '& .details-simple': {
                            '& .ra-field': {
                                marginBottom: '10px',
                            },
                            '& .rs-input-group-inside': {
                                padding: '3px',
                            },
                        },
                    },
                    '& .MuiFormControl-root': {
                        width: '100%',
                        '&.MuiFormControl-marginDense': {
                            marginTop: '4px',
                        },
                    },
                    '&--header': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        '& h4': {
                            letterSpacing: '-0.7px',
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                fontSize: '22px',
                            },
                        },
                        '& .MuiIconButton-root': {
                            margin: '0 0 0 12px',
                            padding: '12px 16px',
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                padding: '12px',
                            },
                            '&.refresh-icon': {
                                backgroundColor: Palette.gray.gray150,
                                margin: '0 19px 0 5px',
                                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                                    margin: '0',
                                },
                                '&:hover': {
                                    boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
                                },
                                '&:disabled': {
                                    '& svg': {
                                        '& path': {
                                            stroke: Palette.gray.gray300,
                                        },
                                    },
                                },
                            },
                        },
                        '& .MuiButton-text': {
                            backgroundColor: Palette.gray.gray100,
                            marginTop: '-6px',
                            borderRadius: '12px',
                        },
                        '& .MuiButton-containedPrimary': {
                            '&.active': {
                                backgroundColor: Palette.yellow.yellow200,
                                boxShadow: `inset 0 0 0 2px ${Palette.yellow.yellow600} !important`,
                                outline: 'none !important',
                            },
                        },
                        '& .popup-box__more-actions-grey': {
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                display: 'flex',
                            },
                            '& .MuiButtonBase-root.MuiButton-root, & .MuiIconButton-root': {
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    padding: '8px',
                                    minWidth: '44px',
                                    margin: '0 0 0 8px',
                                },
                                '& .button-label': {
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        display: 'none',
                                    },
                                },
                                '& .MuiButton-icon': {
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        margin: '0',
                                    },
                                },
                            },
                        },
                        '& + .MuiCollapse-root .MuiCollapse-wrapper': {
                            marginTop: '24px',
                        },
                    },
                    '& .no-label': {
                        '& .RaLabeled-label': {
                            display: 'none',
                        },
                    },
                    '& .label-center': {
                        '& .MuiStack-root.ra-field': {
                            alignItems: 'center !important',
                        },
                    },
                    '& .two-columns-show-layout': {
                        position: 'relative',
                        paddingTop: '20px',
                        width: '100%',
                        '& .no-label.image': {
                            display: 'block',
                            position: 'absolute',
                            maxWidth: '100px',
                            top: '12px',
                            left: '0',
                        },
                        '& > .RaSimpleShowLayout-stack': {
                            '& .details-sample-list': {
                                paddingLeft: '86px',
                                marginTop: '0',
                                '& > div .MuiStack-root.ra-field': {
                                    width: '100%',
                                    padding: '12px 0',
                                    alignItems: 'baseline',
                                },
                                '& .RaLabeled-label': {
                                    minWidth: '190px',
                                },
                            },
                        },
                    },
                    '&--image': {
                        display: 'flex',
                        marginBottom: '40px',
                        alignItems: 'center',
                        '& .image': {
                            borderRadius: '16px',
                            minWidth: '172px',
                            maxWidth: '172px',
                            height: '172px',
                            border: `2px solid ${Palette.gray.gray100}`,
                            overflow: 'hidden',
                            padding: '0px',
                            marginRight: '20px',
                            '& .RaLabeled-label': {
                                display: 'none',
                            },
                            '& .ra-field-pictureUrl .MuiBox-root': {
                                position: 'relative',
                                overflow: 'hidden',
                                height: '172px',
                                '& .RaImageField-image': {
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    obiectPosition: 'center',
                                    margin: '0px',
                                },
                            },
                        },
                        '& .title': {
                            '& .name': {
                                '& .RaLabeled-label': {
                                    display: 'none',
                                },
                                '& .MuiTypography-root': {
                                    fontSize: '28px',
                                    fontWeight: '500',
                                    lineHeight: '34px',
                                    fontFamily: 'Rubik, Arial, sans-serif',
                                    letterSpacing: '-0.42px',
                                },
                            },
                            '& .ra-field-ean': {
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '6px',
                                '& .MuiTypography-root': {
                                    fontSize: '16px',
                                    lineHeight: '22px',
                                    color: Palette.black,
                                },
                            },
                        },
                    },
                    '&--statistics': {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '20px',
                        marginBottom: '52px',
                        '& a.statistics-box': {
                            '&:hover': {
                                boxShadow: Palette.boxShadow.elevation3,
                            },
                        },
                        '& .statistics-box': {
                            flex: '1 1 calc(50% - 20px)',
                            boxSizing: 'border-box',
                            padding: '32px',
                            backgroundColor: Palette.gray.gray75,
                            borderRadius: '16px',
                            textDecoration: 'none',
                            color: Palette.black,
                            '& p.MuiTypography-root': {
                                color: Palette.black,
                                fontSize: '16px',
                                margin: '0',
                                '& + span.MuiTypography-root': {
                                    fontSize: '34px',
                                    fontWeight: '700',
                                    lineHeight: '36px',
                                    fontFamily: 'Rubik, Arial, sans-serif',
                                    marginTop: '4px',
                                    display: 'block',
                                },
                                '& svg': {
                                    marginBottom: '3px',
                                },
                            },
                        },
                    },
                    '&--no-categories': {
                        display: 'none',
                    },
                    '&--categories': {
                        marginBottom: '50px',
                        '& .RaLabeled-label': {
                            display: 'none',
                        },
                        '& .MuiTable-root': {
                            fontSize: '14px',
                            color: Palette.black,
                            display: 'block',
                            '& .MuiTableCell-root': {
                                padding: '8px',
                                maxWidth: '100%',
                                '&:first-of-type': {
                                    width: '154px',
                                },
                            },
                            '& .MuiTableHead-root': {
                                display: 'none',
                            },
                            '& .MuiLink-root .MuiChip-root': {
                                color: Palette.black,
                                height: 'inherit',
                            },
                            '& .tag-list .MuiTypography-root span': {
                                color: Palette.black,
                                fontSize: '14px',
                                lineHeight: '20px',
                                padding: '7px 12px',
                                borderRadius: '8px',
                                display: 'block',
                            },
                        },
                    },
                    '& .MuiAlert-root': {
                        overflow: 'auto',
                    },
                    '& .MuiTypography-h6': {
                        fontSize: '14px',
                        fontFamily: 'Inter, Arial, sans-serif',
                        fontWeight: 600,
                        lineHeight: '20px',
                        letterSpacing: '-0.14px',
                        color: Palette.gray.gray900,
                        marginBottom: '20px',
                    },
                    '& .working-hours': {
                        '& .MuiFormControl-root .MuiInputBase-root': {
                            minWidth: '202px',
                        },
                    },
                    '& .details-sample-list': {
                        '& > div': {
                            padding: '0',
                            '& .MuiStack-root.ra-field': {
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                borderTop: `2px solid ${Palette.gray.gray75}`,
                                borderBottom: `2px solid ${Palette.gray.gray75}`,
                                marginBottom: '-2px',
                                padding: '12px 0',
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    display: 'block',
                                },
                                '&.ra-field-isActive': {
                                    alignItems: 'center !important',
                                },
                                '& .ads-campaigns-period-item': {
                                    padding: '0px',
                                },
                                '& .tag-list': {
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        marginTop: '8px',
                                    },
                                    '& .MuiTypography-root .MuiTypography-body1': {
                                        fontSize: '12px',
                                        lineHeight: '16px',
                                        padding: '7px 12px',
                                        borderRadius: '8px',
                                        display: 'block',
                                    },
                                },
                                '&.ra-field-serialNumber': {
                                    '& span.MuiTypography-body2': {
                                        fontSize: '18px',
                                        fontFamily: 'Rubik, Arial, sans-serif',
                                        fontWeight: '700',
                                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                            wordBreak: 'break-word',
                                            display: 'contents',
                                        },
                                    },
                                },
                                '&.ra-field-config': {
                                    '& pre': {
                                        whiteSpace: 'normal',
                                        fontSize: '12px',
                                        lineHeight: 'normal',
                                    },
                                },
                                '& .RaLabeled-label': {
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    lineHeight: '18px',
                                    width: '140px',
                                    minWidth: '140px',
                                    color: Palette.gray.gray700,
                                    margin: '0',
                                    paddingRight: '10px',
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        width: 'auto',
                                        lineHeight: '20px',
                                    },
                                },
                                '& span.MuiTypography-body2': {
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: Palette.black,
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        wordBreak: 'break-word',
                                        display: 'block',
                                    },
                                    '& .MuiTypography-root.MuiTypography-body1, .MuiTypography-root.MuiTypography-body2': {
                                        fontSize: '14px',
                                    },
                                    '&.bold': {
                                        fontWeight: '600',
                                        '& .MuiButtonBase-root.MuiButton-root': {
                                            fontWeight: '600',
                                        },
                                    },
                                },
                            },
                        },
                        '&.device-details-collapse-wrapper': {
                            '& .column-status': {
                                '& .MuiTypography-root': {
                                    whiteSpace: 'nowrap',
                                },
                            },
                            '& .message-box .MuiTypography-root.MuiTypography-body1': {
                                whiteSpace: 'normal !important',
                            },
                            '& .padding-wrapper .padding-wrapper': {
                                padding: '0 56px 56px 56px !important',
                            },
                            '& .filter-field': {
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    marginTop: '-20px',
                                },
                            },
                            '& .filter-field, & .MuiTablePagination-root': {
                                position: 'relative',
                                maxWidth: '772px',
                            },

                            '& .popup-box.popup-box--header': {
                                padding: '24px 56px',
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    padding: '20px',
                                    // borderBottom: `2px solid ${Palette.gray.gray100}`,
                                },
                            },
                            '& .device-details-collapse': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '40px',
                                // padding: '0 56px 56px 56px',
                                width: '100%',
                                boxSizing: 'border-box',
                                '& .details-date': {
                                    '& .MuiTypography-root span': {
                                        whiteSpace: 'nowrap',
                                    },
                                    '& .MuiStack-root.ra-field': {
                                        width: 'auto',
                                    },
                                },
                                '& > div': {
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    '& .custom-select-array-input': {
                                        '& .MuiFormControl-root': {
                                            width: '100%',
                                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                                minWidth: '100%',
                                            },
                                            '& .chips-container': {
                                                margin: '10px 0px -31px 14px',
                                            },
                                        },
                                    },
                                },
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    flexDirection: 'column',
                                    gap: '12px',
                                },
                                '& .MuiStack-root.ra-field': {
                                    flexDirection: 'column !important',
                                    gap: '2px',
                                    padding: '17px 0 17px 32px !important',
                                    borderBottom: 'none !important',
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        padding: '20px 32px 20px 32px !important',
                                        margin: '0px',
                                    },
                                    '&.ra-field-productionDate': {
                                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                            padding: '0px 32px 20px 32px !important',
                                            borderTop: 'none',
                                            marginTop: '20px',
                                        },
                                    },
                                },
                                '& .ra-field .MuiTypography-root.MuiTypography-body2': {
                                    fontSize: '16px !important',
                                    fontWeight: '600',
                                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                        lineHeight: '22px',
                                    },
                                },
                            },
                        },
                    },
                    '& .device-details-stats': {
                        paddingBottom: '64px',
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            paddingBottom: '40px',
                        },
                        '& .MuiTypography-h5': {
                            fontSize: '22px',
                            lineHeight: '28px',
                            letterSpacing: '-0.44px',
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                fontSize: '18px',
                                lineHeight: '24px',
                            },
                        },
                        '& .period-form': {
                            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                margin: '16px 0 0px',
                            },
                        },
                    },
                },
                '& .pos-details-collapse-wrapper': {
                    borderTop: `2px solid ${Palette.gray.gray100}`,
                    '& .popup-wrapper': {
                        padding: '20px',
                    },
                    '& .popup-box.popup-box--header': {
                        padding: '0px !important',
                        '& .MuiTypography-h5': {
                            margin: '0',
                            fontSize: '18px',
                        },
                    },
                    '& .collapse-button:hover, & .collapse-button:active, & .collapse-button:focus': {
                        backgroundColor: Palette.white,
                        boxShadow: `inset 0 0 0 2px ${Palette.black}`,
                        outline: `2px solid ${Palette.yellow.yellow200} !important`,
                    },
                    '& .details-sample-list': {
                        border: 'none !important',
                        marginTop: '20px',
                        '& > div': {
                            minWidth: '100%',
                            padding: '0',
                            borderTop: `2px solid ${Palette.gray.gray100}`,
                        },
                        '&:last-of-type': {
                            borderBottom: `2px solid ${Palette.gray.gray100}`,
                        },
                        '& .MuiTypography-root': {
                            fontSize: '14px',
                        },
                        '& .ra-field.editable-field': {
                            display: 'block',
                            '&.editable-field--active': {},
                            '& .editable-field-content': {
                                marginTop: '0',
                            },
                        },
                    },
                    '& .device-details-stats': {
                        '&:first-of-type': {
                            marginTop: '20px',
                        },
                        marginTop: '46px',
                        paddingBottom: '0',
                        '& .MuiChip-root': {
                            padding: '11px 16px',
                            '& .MuiChip-label': {
                                fontSize: '14px',
                            },
                        },
                    },
                },
                '& .product-details': {
                    display: 'flex',
                    width: '100%',
                    gap: '40px',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        flexDirection: 'column',
                        gap: '20px',
                    },
                    '& .column': {
                        flex: '50%',
                        maxWidth: '50%',
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            flex: '100%',
                            maxWidth: '100%',
                            minWidth: '100%',
                        },
                        '& > div': {
                            padding: '20px 32px',
                            borderTop: `2px solid ${Palette.gray.gray100}`,
                            minHeight: '44px',
                        },
                        '& .RaLabeled-label': {
                            fontSize: '14px',
                            color: Palette.black,
                            lineHeight: '20px',
                        },
                        '& span.MuiTypography-root': {
                            fontSize: '16px',
                            color: Palette.black,
                            fontWeight: '600',
                            lineHeight: '22px',
                            overflowWrap: 'break-word',
                        },
                    },
                },
                '& .loading, & .error, & .warning, & .info': {
                    fontFamily: 'Rubik, Arial, sans-serif',
                    fontWeight: 400,
                    margin: '80px auto',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px 24px',
                    borderRadius: '16px',
                    '&::before': {
                        content: '""',
                        width: '22px',
                        height: '22px',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        display: 'block',
                        marginRight: '12px',
                        backgroundSize: '100% auto',
                    },
                    '& strong': {
                        paddingLeft: '7px',
                        fontWeight: '500',
                    },
                },
                '& .loading': {
                    '&::after': {
                        content: '""',
                        animation: 'dots 1.5s infinite steps(4)',
                        width: '10px',
                    },
                },
                '& .error': {
                    backgroundColor: Palette.red.red50,
                    '&::before': {
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='icon'%3E%3Cpath id='Vector 2' d='M14.6117 3.62068L22.47 17.5238C23.6004 19.5237 22.1555 22 19.8583 22H4.1417C1.84448 22 0.399647 19.5237 1.53001 17.5238L9.38831 3.62068C10.5367 1.58891 13.4633 1.58891 14.6117 3.62068Z' fill='%23FF615E' stroke='%231A1A1A' stroke-width='2'/%3E%3Ccircle id='Ellipse 4' cx='12' cy='17.5' r='0.5' fill='%231A1A1A' stroke='%231A1A1A' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3Crect id='Rectangle 7' x='11' y='7' width='2' height='7.5' rx='1' fill='%231A1A1A'/%3E%3C/g%3E%3C/svg%3E")`,
                    },
                },
                '& .warning': {
                    backgroundColor: Palette.yellow.yellow50,
                    '&::before': {
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='icon'%3E%3Cpath id='Vector 2' d='M14.6117 3.62068L22.47 17.5238C23.6004 19.5237 22.1555 22 19.8583 22H4.1417C1.84448 22 0.399647 19.5237 1.53001 17.5238L9.38831 3.62068C10.5367 1.58891 13.4633 1.58891 14.6117 3.62068Z' fill='%23FFC800' stroke='%231A1A1A' stroke-width='2'/%3E%3Ccircle id='Ellipse 4' cx='12' cy='17.5' r='0.5' fill='%231A1A1A' stroke='%231A1A1A' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3Crect id='Rectangle 7' x='11' y='7' width='2' height='7.5' rx='1' fill='%231A1A1A'/%3E%3C/g%3E%3C/svg%3E")`,
                    },
                },
                '& .RaSimpleFormIterator-line': {
                    border: 'none',
                },
                '& .MuiToolbar-root.MuiToolbar-gutters': {
                    backgroundColor: 'transparent',
                    padding: '0px',
                    position: 'relative',
                    minHeight: 'auto',
                },
                '& .MuiCardContent-root': {
                    padding: '0px',
                },
                '& .RaEdit-main.RaEdit-noActions': {
                    marginTop: '0px',
                    '& .editable-field--active': {
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            display: 'block !important',
                            paddingLeft: '2px',
                            paddingRight: '2px',
                        },
                        '& .date-picker': {
                            width: '100%',
                            margin: '0px',
                        },
                        '& .rs-picker': {
                            marginBottom: '0px',
                            marginTop: '0px',
                        },
                        '& .rs-picker-popup-date': {
                            '& .rs-calendar-header': {
                                '&::before, &::after': {
                                    display: 'none !important',
                                },
                                '& .rs-calendar-header-month-toolbar': {
                                    '&::before': {
                                        display: 'none !important',
                                    },
                                },
                            },
                        },
                    },
                },
            },
            '& .more-content': {
                '& .MuiButtonBase-root': {
                    backgroundColor: Palette.white,
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: Palette.gray.gray150,
                        boxShadow: 'none',
                    },
                },
            },
        },
    },
};
